import { FormControlLabel, Grid, Radio, RadioGroup, Switch } from "@mui/material";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import Campo from "../Campo";
import { PRECIO_MAXIMO_EVENTO } from "../../utils";

const opcion = (titulo, detalle) => (
  <SoftBox>
    <SoftTypography variant="button" fontWeight="bold" display="block">{titulo}</SoftTypography>
    <SoftTypography variant="caption" color="secondary">{detalle}</SoftTypography>
  </SoftBox>
);

export default function PasoMenu({ form, setField, errores, soloLectura }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SoftBox display="flex" alignItems="center" gap={1}>
          <Switch checked={form.menuUniversitario} disabled={soloLectura} onChange={(_, value) => setField("menuUniversitario", value)}
            inputProps={{ "aria-label": "Vender platos del menú universitario" }} />
          <SoftTypography variant="button" fontWeight="bold">Vender platos del menú universitario</SoftTypography>
        </SoftBox>
        <SoftTypography variant="caption" color="secondary" display="block">
          Se ofrecen los platos del cronograma del día para el turno más cercano a la hora actual.
        </SoftTypography>
      </Grid>

      {form.menuUniversitario && (
        <>
          <Grid item xs={12}>
            <Campo label="Precio de cada plato">
              <RadioGroup value={form.menuModoPrecio} onChange={(e) => setField("menuModoPrecio", e.target.value)}>
                <FormControlLabel value="COMPRADOR" control={<Radio disabled={soloLectura} />} sx={{ alignItems: "flex-start", mb: 1 }}
                  label={opcion("Tarifa de cada comprador", "Según el DNI ingresado; sin DNI o fuera de la comunidad UPrO, tarifa Particular.")} />
                <FormControlLabel value="FIJO" control={<Radio disabled={soloLectura} />} sx={{ alignItems: "flex-start" }}
                  label={opcion("Precio fijo", "El mismo precio para todos los platos y compradores.")} />
              </RadioGroup>
            </Campo>
          </Grid>
          {form.menuModoPrecio === "FIJO" && (
            <Grid item xs={12} sm={6} md={4}>
              <Campo id="evento-precio-menu" label="Precio fijo" requerido error={errores.menuUniversitarioPrecio}>
                <SoftInput id="evento-precio-menu" type="number" value={form.menuUniversitarioPrecio} disabled={soloLectura}
                  onChange={(e) => setField("menuUniversitarioPrecio", e.target.value)}
                  error={Boolean(errores.menuUniversitarioPrecio)} icon={{ component: "attach_money", direction: "left" }}
                  inputProps={{ min: 0.01, max: PRECIO_MAXIMO_EVENTO, step: 0.01, disabled: soloLectura }} />
              </Campo>
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
}

PasoMenu.propTypes = {
  form: PropTypes.object.isRequired,
  setField: PropTypes.func.isRequired,
  errores: PropTypes.object.isRequired,
  soloLectura: PropTypes.bool,
};

PasoMenu.defaultProps = { soloLectura: false };
